<template>
    <div id="reviews">
        <div v-if="loading">
            <device-details-reviews-skeleton />
        </div>
        <template v-else>
            <div class="d-flex flex-row justify-content-between">
                <div class="pb-1 lead fw-bold">
                    <div v-if="deviceReviews.length > 0">
                        {{ reviewsOffsetMessage }}
                    </div>
                    <div v-else>
                        {{ reviewsMessages.noResultReviewsMessage }}
                    </div>
                </div>
                <div class="d-md-none">
                    <ob1-liens-icone
                        is-button
                        :mini="true"
                        modal-id="slide-filters-reviews-modal"
                        title="Filtrer"
                        class="noDefaultStyleButton"
                        data-bs-toggle="modal"
                        icon="icon-filter"
                        type="button"
                    />
                </div>
            </div>
            <reviews-details
                :device-reviews="deviceReviews"
                :verified="reviewsMessages.verified"
            />
        </template>
    </div>
</template>

<script>
import ReviewsDetails from "./ReviewsDetails.vue";
import DeviceDetailsReviewsSkeleton from "./DeviceDetailsReviewsSkeleton.vue";

export default {
    name: "DeviceDetailsReviews",
    components: {DeviceDetailsReviewsSkeleton, ReviewsDetails},
    props: {
        totalReviewCount: {
            type: Number,
            required: true
        },
        deviceReviews: {
            type: Array,
            required: true
        },
        loading: {
            type: Boolean,
            required: true
        },
        reviewsMessages: {
            type: Object,
            required: true
        },
    },
    computed: {
        reviewsOffsetMessage() {
            let realTotal = Math.max(this.totalReviewCount, this.deviceReviews.length);
            return `1 - ${this.deviceReviews.length} sur ${realTotal} ${this.reviewsMessages.message}`;
        },
    }
}
</script>
